import axiosAuth from "@/services/axiosAuth";
import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { KPL_FINANCIAL_API } from "./apiRoutes";

interface UseGetKplFinancialReportingProps {
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getKplFinancialReporting = async () =>
  await axiosAuth.get(`${KPL_FINANCIAL_API}/`);

const useGetKplFinancialReporting = ({
  queryParams,
}: UseGetKplFinancialReportingProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["financial-reporting"],
    queryFn: () => getKplFinancialReporting(),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    enabled: queryParams?.enabled,
    ...queryParams,
  });
};

export default useGetKplFinancialReporting;
